export function debounce(callback: Function, delay: number) {
  let timeoutId: number | null = null;

  return () => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(callback, delay);
  };
}